import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading, isAdmin } = useAuth();

  // console.log supprimé

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (!user || !user.emailVerified || !isAdmin) {
    console.log('Access denied:', {
      hasUser: !!user,
      emailVerified: user?.emailVerified,
      isAdmin
    });
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}

